var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddCircleGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5126_1805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    width: 181.87,
    height: 183,
    rx: 90.9352,
    fill: "#4D4D4D",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0248 83.8979L99.0113 57.6258C98.8949 55.8046 98.0893 54.096 96.7583 52.8473C95.4273 51.5987 93.6708 50.9038 91.8459 50.9038C90.0209 50.9038 88.2644 51.5987 86.9334 52.8473C85.6024 54.096 84.7969 55.8046 84.6804 57.6258L84.6669 83.8979L58.3305 83.8945C57.3873 83.8945 56.4533 84.0803 55.5819 84.4413C54.7105 84.8022 53.9188 85.3312 53.2518 85.9982C52.5849 86.6651 52.0558 87.4569 51.6949 88.3283C51.3339 89.1997 51.1481 90.1337 51.1481 91.0769C51.1481 92.0201 51.3339 92.954 51.6949 93.8254C52.0558 94.6968 52.5849 95.4886 53.2518 96.1556C53.9188 96.8225 54.7105 97.3516 55.5819 97.7125C56.4533 98.0734 57.3873 98.2592 58.3305 98.2592L84.6669 98.2558L84.6771 124.525C84.6224 125.5 84.7673 126.476 85.1029 127.393C85.4385 128.31 85.9577 129.149 86.6288 129.859C87.2998 130.569 88.1086 131.134 89.0056 131.521C89.9027 131.907 90.8691 132.106 91.8459 132.106C92.8226 132.106 93.789 131.907 94.6861 131.521C95.5831 131.134 96.3919 130.569 97.063 129.859C97.734 129.149 98.2532 128.31 98.5888 127.393C98.9244 126.476 99.0693 125.5 99.0147 124.525L99.0248 98.2558L125.28 98.2592C127.185 98.2592 129.012 97.5025 130.359 96.1556C131.706 94.8086 132.462 92.9818 132.462 91.0769C132.462 89.172 131.706 87.3451 130.359 85.9982C129.012 84.6512 127.185 83.8945 125.28 83.8945L99.0248 83.8979Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5126_1805",
    x: -6.4375,
    y: -7,
    width: 195.867,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5126_1805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5126_1805",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleGrey);
export default __webpack_public_path__ + "static/media/add-circle-grey.d01e0d4d1d44c679ec00f9241abc6dc3.svg";
export { ForwardRef as ReactComponent };